module.exports = __webpack_public_path__ + "img/icon-profile2.186f01f0.svg";